import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Text } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`The box component is considered a utility component, as it can be used for something as simple as a rounded corner box. `}</p>
    <p>{`By default there are no additional styles, as these can be achieved using styled system props to enable custom theme-aware styling.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      